import React, { Component } from 'react';
import { userLogout } from '../../common/globals';
import { deleteDb } from '../../utils/db';
import withUser from '../../common/withUser';
import Bugsnag from '../../helpers/bugsnag';

class RemoteWipeModal extends Component {
  _onOK = async () => {
    try {
      const { setUser } = this.props;
      await userLogout(true);
      setUser({});
      await deleteDb();
      window.localStorage.clear();
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    return (
      <div
        className="modal fade theme-modal" id="remoteWipeModal"
        tabIndex="-1" aria-labelledby="remoteWipeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title" id="remoteWipeModalLabel">Attention</h5>
              <p>A remove wipe has been requested for this user</p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-12">
                  <button
                    type="button" className="btn btn-theme w-100"
                    onClick={this._onOK}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withUser(
  RemoteWipeModal
);
